export enum MembershipRenewalStepEnum {
    PersonalDetails = 'Personal details',
    PostalAddress = 'Postal address',
    Location = 'Location of practice',
    Declaration = 'Declaration',
    PaymentAndSummary = 'Payment'
}